// extracted by mini-css-extract-plugin
export var audioPlayer = "_sr-0";